import { $httpWithGateway } from "./common/request"

interface IData {
  [key: string]: string | number | any
}

interface IRequestConfig {
  [key: string]: string | number | any
}

type pushDevFingerPointParams = {
  cfrnid: string
  ruid: string
  uid: string
  bizSystemInfo: string
}

/**
 * 查询一阶段结果
 * @param data
 */
export const queryPhaseOneResult = (
  data?: IData,
  config?: IRequestConfig
) =>
  $httpWithGateway(
    `/applyCard/current/queryPhaseOneResult`,
    data,
    config
  )

/**
 * 查询下一页面
 * @param data
 */
export const getNextPage = (
  data?: IData,
  config?: IRequestConfig
) => {
  return $httpWithGateway(
    `/applyCard/current/getNextPage`,
    data,
    {
      ...config,
      loading: true,
    }
  )
}

/**
 * 查询引导页1
 * @param data
 */
export const queryStartNowPage = (
  data?: IData,
  config?: IRequestConfig
) =>
  $httpWithGateway(
    `/applyCard/guidePage/queryStartNowPage`,
    data,
    {
      timeoutToast: false,
      toastError: false,
      ...config,
    }
  )

/**
 * 提交引导页1
 * @param data
 */
export const saveStartNowPage = (
  data?: IData,
  config?: IRequestConfig
) =>
  $httpWithGateway(
    `/applyCard/guidePage/saveStartNowPage`,
    data,
    config
  )

/**
 * 查询引导页2
 * @param data
 */
export const queryCongratesPage = (
  data?: IData,
  config?: IRequestConfig
) =>
  $httpWithGateway(
    `/applyCard/guidePage/queryCongratesPage`,
    data,
    {
      timeoutToast: false,
      toastError: false,
      ...config,
    }
  )

/**
 * 提交引导页2
 * @param data
 */
export const saveCongratesPage = (
  data?: IData,
  config?: IRequestConfig
) =>
  $httpWithGateway(
    `/applyCard/guidePage/saveCongratesPage`,
    data,
    config
  )

/**
 * 查询征信授权页
 * @param data
 */
export const queryCreditGrantPageInfo = (
  data?: IData,
  config?: IRequestConfig
) =>
  $httpWithGateway(
    `/applyCard/current/queryCreditGrantPageInfo`,
    data,
    {
      timeoutToast: false,
      toastError: false,
      ...config,
    }
  )

/**
 * 发送征信验证码
 * @param data
 */
export const sendCreditGrantSmCode = (
  data?: IData,
  config?: IRequestConfig
) =>
  $httpWithGateway(
    `/applyCard/current/sendCreditGrantSmCode`,
    data,
    config
  )

/**
 * 确认征信验证码
 * @param data
 */
export const confirmCreditGrantSmCode = (
  data?: IData,
  config?: IRequestConfig
) =>
  $httpWithGateway(
    `/applyCard/current/confirmCreditGrantSmCode`,
    data,
    config
  )

/**
 * 获取协议名称列表
 */
export const getPreviewProtocolList = (
  data: IData,
  config?: IRequestConfig
) =>
  $httpWithGateway(
    `/protocol/getPreviewProtocolList`,
    data,
    config
  )

/**
 * 获取预览协议
 */
export const getPreviewProtocolContent = (
  data: IData,
  config?: IRequestConfig
) =>
  $httpWithGateway(
    `/protocol/getPreviewProtocolContent`,
    data,
    config
  )

/**
 * 设备指纹上报-页面打开时上传信息给flow
 */
export const pushDevFingerPoint = (
  data?: pushDevFingerPointParams,
  config?: any
) =>
  $httpWithGateway(`/riskData/pushDevFingerPoint`, data, {
    toastError: true,
    ...config,
  })

/**
 * 查询虚实分离个人信息1页
 * @param data
 */
export const queryCardSeparatePersonalInfo1 = (
  data?: IData,
  config?: IRequestConfig
) =>
  $httpWithGateway(
    `/applyCard/baseInfo/queryCardSeparatePersonalInfo1`,
    data,
    {
      timeoutToast: false,
      toastError: false,
      ...config,
    }
  )

/**
 * 提交虚实分离个人信息1页
 * @param data
 */
export const saveCardSeparatePersonalInfo1 = (
  data?: IData,
  config?: IRequestConfig
) =>
  $httpWithGateway(
    `/applyCard/baseInfo/saveCardSeparatePersonalInfo1`,
    data,
    config
  )

export const getCreditConfig = (
  data?: IData
) =>
  $httpWithGateway(
    `/config/getMenu`,
    data
  )

/**
 * 查询curp页
 * @param data
 */
export const queryCurpPage = (
  data?: IData,
  config?: IRequestConfig
) =>
  $httpWithGateway(
    `/applyCard/current/queryCurpPage`,
    data,
    config
  )

/**
 * 获取用户信息
 */
export const valid = <T = any>(data?: any, config?: any) =>
  $httpWithGateway(`/passport/valid`, data, {
    toastError: false,
    ...config,
  })

/**
 * 提交curp页
 * @param data
 */
export const saveCurpPage = (
  data?: IData,
  config?: IRequestConfig
) =>
  $httpWithGateway(
    `/applyCard/current/saveCurpPage`,
    data,
    config
  )

/**
 * 查询并签署平台协议
 * @param data 
 * @param config 
 */
export const signPlatform = (
  data: {
    stage: string
  },
  config?: IRequestConfig
) => {
  return $httpWithGateway(
    `/contract/externalSignContract`,
    data,
    config
  )
}

/**
 * 查询首页信息
 * @param data
 * @param config
 */
export const getHomePageInfo = (
  data?: IData,
  config?: IRequestConfig
) => {
  return $httpWithGateway(
    `/home/index`,
    {
      externalFlag: 1, // 端外标识 首页接口和下一页接口必传
      ...data,
    },
    config
  )
}

/**
 * 获取登录页apollo
 * @param data 
 * @param config
 * @returns 
 */
export const getLoginApollo = (
  data?: IData,
  config?: IRequestConfig
) => {
  return $httpWithGateway(
    `/apollo/login`,
    data,
    config
  )
}
